/**
 * Окно «Визуалы и черновики» пряников: те же шаги 6 «Визуалы» и 7 «Карточки», что в мастере «Создать пряники»,
 * отдельным окном для выбранных PP0/PP1 (массовое действие каталога, вкладка «Производство» товара).
 *
 * Окно можно закрыть: генерация идёт в фоне, запуски видны на странице воронок и открываются здесь снова.
 */

import { useEffect, useState } from 'react'
import { Button, Modal } from '../../../components/ui'
import { UnderlineTabs } from '../../../components/ui/UnderlineTabs'
import { useAuthStore } from '../../../stores/authStore'
import { CardsStep } from './CardsStep'
import { useTargetSelection } from './hooks'
import { VisualsStep } from './VisualsStep'

export type VisualsCardsStep = 'visuals' | 'cards'

export interface VisualsCardsDialogProps {
  isOpen: boolean
  onClose: () => void
  articles: string[]
  initialStep?: VisualsCardsStep
}

const TABS: Array<{ key: VisualsCardsStep; label: string }> = [
  { key: 'visuals', label: '1. Визуалы' },
  { key: 'cards', label: '2. Карточки' },
]

export default function VisualsCardsDialog({ isOpen, onClose, articles, initialStep = 'visuals' }: VisualsCardsDialogProps) {
  const permissions = useAuthStore((state) => state.user?.permissions || [])
  const canRun = permissions.includes('ContentFunnel:UPDATE')
  const selection = useTargetSelection()
  const [step, setStep] = useState<VisualsCardsStep>(initialStep)
  const { ensureLoaded, reset } = selection

  useEffect(() => {
    if (!isOpen) return
    setStep(initialStep)
    ensureLoaded()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, initialStep])

  // Закрытое окно кабинеты не держит: при следующем открытии выбор собирается заново.
  useEffect(() => {
    if (!isOpen) reset()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const count = articles.length
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Визуалы и черновики карточек"
      subtitle={`Пряников и наборов: ${count.toLocaleString('ru-RU')}`}
      size="xl"
      closeOnOverlayClick
      footer={
        <div className="flex w-full items-center justify-end gap-2">
          {step === 'cards' && <Button variant="secondary" onClick={() => setStep('visuals')}>Назад к визуалам</Button>}
          {step === 'visuals' && <Button variant="secondary" onClick={() => setStep('cards')}>Далее: карточки</Button>}
          <Button variant="primary" onClick={onClose}>Закрыть</Button>
        </div>
      }
    >
      <UnderlineTabs<VisualsCardsStep> ariaLabel="Шаги визуалов и карточек" tabs={TABS} active={step} onChange={setStep} className="mb-4" />
      {step === 'visuals' ? (
        <VisualsStep articles={articles} selection={selection} canRun={canRun} />
      ) : (
        <CardsStep articles={articles} selection={selection} canRun={canRun} />
      )}
    </Modal>
  )
}
